import React from "react";
import { CaretLeft, CaretRight, CaretDoubleLeft, CaretDoubleRight } from "@phosphor-icons/react";
import { Button } from "./ui/button";

export default function Pagination({ page, totalPages, total, pageSize, onChange, testIdPrefix = "pg" }) {
  if (!totalPages || totalPages < 1) return null;
  const p = Math.max(1, Math.min(page, totalPages));
  const from = (p - 1) * pageSize + 1;
  const to = Math.min(p * pageSize, total || 0);

  // Generate page numbers with ellipsis: 1 ... p-1 p p+1 ... last
  const pages = [];
  const push = (n) => pages.push(n);
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) push(i);
  } else {
    push(1);
    if (p > 3) push("…l");
    for (let i = Math.max(2, p - 1); i <= Math.min(totalPages - 1, p + 1); i++) push(i);
    if (p < totalPages - 2) push("…r");
    push(totalPages);
  }

  return (
    <div className="flex items-center justify-between px-4 py-3 bg-muted/30 border-t border-border flex-wrap gap-2" data-testid={`${testIdPrefix}-pagination`}>
      <div className="text-xs text-muted-foreground font-mono">
        Menampilkan <b>{total > 0 ? from : 0}</b>–<b>{to}</b> dari <b>{total || 0}</b> data
      </div>
      <div className="flex items-center gap-1">
        <Button size="sm" variant="outline" onClick={() => onChange(1)} disabled={p === 1} data-testid={`${testIdPrefix}-first`} className="h-8 w-8 p-0"><CaretDoubleLeft size={14} /></Button>
        <Button size="sm" variant="outline" onClick={() => onChange(p - 1)} disabled={p === 1} data-testid={`${testIdPrefix}-prev`} className="h-8 w-8 p-0"><CaretLeft size={14} /></Button>
        {pages.map((n, i) => n === "…l" || n === "…r" ? (
          <span key={n + i} className="px-2 text-xs text-muted-foreground">…</span>
        ) : (
          <button key={n} onClick={() => onChange(n)}
            className={`h-8 min-w-[32px] px-2 rounded-md text-xs font-bold border transition-colors ${n === p ? "bg-[#0B8D95] text-white border-[#0B8D95]" : "bg-white border-border text-foreground hover:bg-muted"}`}
            data-testid={`${testIdPrefix}-page-${n}`}>{n}</button>
        ))}
        <Button size="sm" variant="outline" onClick={() => onChange(p + 1)} disabled={p === totalPages} data-testid={`${testIdPrefix}-next`} className="h-8 w-8 p-0"><CaretRight size={14} /></Button>
        <Button size="sm" variant="outline" onClick={() => onChange(totalPages)} disabled={p === totalPages} data-testid={`${testIdPrefix}-last`} className="h-8 w-8 p-0"><CaretDoubleRight size={14} /></Button>
      </div>
    </div>
  );
}
